// Templates de prompt pour le mini-cours — source unique de vérité.
// Auparavant dupliqués entre ExercisePage.tsx (~1040-1067) et MiniCoursFirstPage.tsx
// (~84-118). Toute modification du wording DOIT se faire ici uniquement.

export interface MiniCoursBasePromptOptions {
  title: string;
  description: string;
  concepts: string[];
  modeLabel: string;
}

export function buildMiniCoursBasePrompt({
  title,
  description,
  concepts,
  modeLabel,
}: MiniCoursBasePromptOptions): string {
  return `Crée un mini-cours concis pour aider l'étudiant à comprendre les concepts nécessaires pour cet exercice :

EXERCICE: "${title}"
DESCRIPTION: ${description}
CONCEPTS: ${concepts.join(', ')}

FORMAT REQUIS:
- Utilise **gras** pour les mots-clés importants
- Utilise > pour les citations importantes (ex: > Point crucial à retenir)
- Structure en 3-4 paragraphes maximum
- Explique les concepts ${modeLabel} nécessaires
- Donne des exemples concrets liés à l'exercice
- Reste focalisé sur ce qui est NÉCESSAIRE pour réussir

NIVEAU: Intermédiaire (assume des bases en programmation)`;
}

export function buildMiniCoursSimplifyPrompt(
  previousExplanation: string,
  level: number,
): string {
  return `Simplifie encore plus cette explication pour un débutant absolu qui pourrait ne pas connaître les concepts de base :

EXPLICATION PRÉCÉDENTE:
${previousExplanation}

SIMPLIFICATION NIVEAU ${level}:
- Décompose CHAQUE terme technique
- Explique les concepts de base (variables, méthodes, etc.)
- Ajoute plus d'exemples du quotidien
- Utilise un langage encore plus simple
- Assume AUCUNE connaissance préalable

Plus le niveau est élevé, plus tu dois expliquer les bases fondamentales.`;
}
